import { createRoot } from 'react-dom/client'
import { AuthProviderProps } from 'oidc-react'

import reportWebVitals from 'Shared/utils/reportWebVitals'

import RootApp from 'Core/common/RootApp'

import { setAxiosInstance } from '../axios'

import { Initialize } from './types'

const initialize: Initialize = ({ AuthInstance, rootStore, isSmallScreenStub, component }) => {
	const container = document.getElementById('root')!
	const root = createRoot(container)
	let authConfig: AuthProviderProps | undefined = undefined
	setAxiosInstance(AuthInstance)

	if (AuthInstance) {
		AuthInstance.runInactivityWorker()
		authConfig = AuthInstance.getConfig()
	}
	reportWebVitals()

	root.render(
		<RootApp
			children={component}
			authConfig={authConfig}
			rootStore={rootStore}
			isSmallScreenStub={isSmallScreenStub}
		/>
	)
}

export default initialize
